import forms from 'scenes/form/i18n/ar.js';
import home from 'scenes/home/i18n/ar.js';
import calltoaction from 'scenes/calltoaction/i18n/ar.js';
import simulator from 'scenes/simulator/i18n/ar.js';

const common = {
  goback: 'رجوع',
  send: 'إرسال',
  next: 'التالي',
  confirmation: 'تأكيد',
  successMessage: 'طلبكم تم بنجاح',
  errorMessage: 'Une erreur est survenue',
  close: 'إغلاق',
  copyright: 'حقوق النشر 2020 - مجموعة البنك الشعبي - جميع الحقوق محفوظة',
};
export const ar = {
  forms,
  home,
  calltoaction,
  simulator,
  common,
};
